import { ActivitiesPageTypes } from 'core/constant/analytics/AnalyticsPageType';
import { PageTypes } from 'core/constant/analytics/PageTypes';
import { MobilePageTypes } from 'core/constant/analytics/MobilePageTypes';
import { WebViewPageTypes } from 'core/constant/analytics/WebViewPageType';
import { setupWebAnalytics } from 'core/messaging/analytics/analytics';
import { homePageBinder } from 'core/messaging/analytics/pages/home';
import { searchPageBinder } from 'core/messaging/analytics/pages/search';
import { detailPageBinder } from 'core/messaging/analytics/pages/detail';
import { homePageMobileBinder } from 'core/messaging/analytics/pages/homeMobile';
import { searchPageMobileBinder } from 'core/messaging/analytics/pages/searchMobile';
import { detailPageMobileBinder } from 'core/messaging/analytics/pages/detailMobile';
import { homeWebViewPageBinder } from 'core/messaging/analytics/pages/homeWebView';
import { searchWebViewPageBinder } from 'core/messaging/analytics/pages/searchWebView';
import { detailWebViewPageBinder } from 'core/messaging/analytics/pages/detailWebView';
import { cityPageBinder } from 'core/messaging/analytics/pages/city';
import { cityMobilePageBinder } from 'core/messaging/analytics/pages/cityMobile';
import { cityWebViewPageBinder } from 'core/messaging/analytics/pages/cityWebView';
import { BootstrapConfig } from 'core/type/BootstrapConfig.types';

export const setupAnalyticsContext = (pageTypes: ActivitiesPageTypes, config: BootstrapConfig) => {
    switch (pageTypes) {
        case PageTypes.Home:
            return setupWebAnalytics(homePageBinder, config);
        case PageTypes.Search:
            return setupWebAnalytics(searchPageBinder, config);
        case PageTypes.Details:
            return setupWebAnalytics(detailPageBinder, config);
        case PageTypes.City:
            return setupWebAnalytics(cityPageBinder, config);
        case MobilePageTypes.Home:
            return setupWebAnalytics(homePageMobileBinder, config);
        case MobilePageTypes.Search:
            return setupWebAnalytics(searchPageMobileBinder, config);
        case MobilePageTypes.Details:
            return setupWebAnalytics(detailPageMobileBinder, config);
        case MobilePageTypes.City:
            return setupWebAnalytics(cityMobilePageBinder, config);
        case WebViewPageTypes.Home:
            return setupWebAnalytics(homeWebViewPageBinder, config);
        case WebViewPageTypes.Search:
            return setupWebAnalytics(searchWebViewPageBinder, config);
        case WebViewPageTypes.Details:
            return setupWebAnalytics(detailWebViewPageBinder, config);
        case WebViewPageTypes.City:
            return setupWebAnalytics(cityWebViewPageBinder, config);
        default:
            return setupWebAnalytics(homePageBinder, config);
    }
};
